(function($) {
    window.dataLayer = window.dataLayer || []

    /*
    Other push locations:
    - purchase, contentPurchase, user_data (after purchase) - woocommerce/checkout/thankyou.php
    - user_data (after login) - assets/scripts/woocommerce/login-modal.js, includes/woocommerce/myaccount/ajax-login.php
    - user_data (after registration) - includes/woocommerce/DataLayer.php
     */

    function datalayer_push(source, event = null, data = null, items = null){

        if (source === 'ga'){ // Google Analytics
            if (!Array.isArray(items)){
                items = [items]
            }

            let push_data = {
                event: event,
                ecommerce: {
                    items: items
                }
            }

            if (data){
                $.each(data, function(index, item) {
                    push_data["ecommerce"][index] = item
                })
            }

            window.dataLayer.push(push_data)
        }
        else if (source === 'ads'){ // Ad platforms
            let push_data = {
                event: event
            }
            if (data){
                $.each(data, function(index, item) {
                    push_data[index] = item
                })
            }

            window.dataLayer.push(push_data)
        }
        else {  // Other platforms
            window.dataLayer.push(data)
        }
    }

    function get_checkout_items(){
        let checkout_list_items = []

        $("div.checkout_sidebar div.checkout_review__item[data-layer-product]").each(function () {

            let checkout_item = $(this).attr('data-layer-product')
            if (checkout_item){
                checkout_item = $.parseJSON(checkout_item)

                let variation = $(this).find('p.checkout_review__item_variation')
                if (variation){
                    variation = variation.text().replace('Velikost: ', '').replace('Veľkosť: ', '')
                    checkout_item["item_variant"] = variation
                }
                let quantity = $(this).find('p.checkout_review__item_quantity')
                if (quantity.length){
                    quantity = quantity.text().match(/\d+/)[0]
                    checkout_item["quantity"] = quantity
                }
                else {
                    // Quantity not found, probably a gift
                    checkout_item["quantity"] = 1
                }

                checkout_list_items.push(checkout_item)
            }
        })

        return checkout_list_items
    }

    /*
        PRODUCTS
     */

    // Push viewed product list to data layer
    let product_list_items = []
    $("li[data-layer-product]").each(function (){
        product_list_items.push($.parseJSON($(this).attr('data-layer-product')))
    })

    if (product_list_items.length > 0){
        datalayer_push('ga', 'view_item_list', null, product_list_items)
    }

    // Push clicked product to data layer
    $("a.woocommerce-LoopProduct-link.woocommerce-loop-product__link").click(function (){
        let clicked_product = $(this).closest('[data-layer-product]')
        if (clicked_product.length){
            let product_datalayer = clicked_product.attr('data-layer-product')
            if (product_datalayer.length){
                datalayer_push('ga', 'select_item', null, $.parseJSON(product_datalayer))
            }
        }
    })

    // Push single viewed product to data layer
    let single_product = $('div.product-detail[data-layer-product]')
    if (single_product.length){

        let viewed_product = $.parseJSON(single_product.attr('data-layer-product'))
        if (viewed_product){
            // Google Analytics
            datalayer_push('ga', 'view_item', null, viewed_product)

            // Ads
            let viewContent = {
                "content_ids": [viewed_product["item_id"]],
                "value": parseFloat(viewed_product["price"])
            }
            datalayer_push('ads', 'viewContent', viewContent)
        }
    }

    // Push viewed category to data layer
    let viewed_category = $('div#products-overview')
    if (viewed_category.length){
        let category_name = viewed_category.attr('data-category-name')
        let category_breadcrumb = $('nav.woocommerce-breadcrumb')
        let category_breadcrumb_str = ""
        if (category_breadcrumb.length){
            let crumbs = []
            $.each(category_breadcrumb.children(), function (index, crumb){
                crumbs.push(crumb.innerText)
            })

            if (crumbs.length){
                category_breadcrumb_str = crumbs.join(" > ")
            }
        }

        // Ads
        let content_ids = []
        for (let i = 0; i < 6; i++){
            if (product_list_items[i]){
                content_ids.push(product_list_items[i]["item_id"])
            }
            else {
                break
            }
        }

        if (content_ids.length === 0){
            return
        }

        let viewCategory = {}
        if (category_name){
            viewCategory["content_name"] = category_name
        }
        if (category_breadcrumb_str){
            viewCategory["content_category"] = category_breadcrumb_str
        }
        if (content_ids){
            viewCategory["content_ids"] = content_ids
        }
        datalayer_push('ads', 'viewCategory', viewCategory, null)

        // Zbozi.cz
        let zbozi_category = $("header.archive-product__header[data-product-zbozi-id]").attr('data-product-zbozi-id')
        if (zbozi_category){
            datalayer_push('zbozi', null, {"zbozi_kategorie": zbozi_category})
        }
    }

    /*
        CART
     */

    // View cart
    $(document).on('modal_opened', (event, modal_id) => {

        if(modal_id === "cart"){

            let cart_list_items = []
            $("div.sidebar-cart__item[data-layer-product]").each(function (){
                let cart_item = $(this).attr('data-layer-product')
                if (cart_item){
                    cart_item = $.parseJSON(cart_item)

                    let variation = $(this).find('p.sidebar-cart__item_variations')
                    if (variation){
                        variation = variation.text().replace('Velikost: ', '').replace('Veľkosť: ', '')
                        if (variation.length > 0){
                            cart_item["item_variant"] = variation
                        }
                    }
                    let quantity = $(this).find('div.sidebar-cart__item_quantity')
                    if (quantity){
                        quantity = quantity.find('div.col:nth-of-type(2) > span')
                        if (quantity.length){
                            quantity = quantity.text().match(/\d+/)[0]
                            cart_item["quantity"] = parseInt(quantity)
                        }
                        else {
                            // Quantity not found, probably a gift
                            cart_item["quantity"] = 1
                        }
                    }

                    cart_list_items.push(cart_item)
                }
            })

            datalayer_push('ga', 'view_cart', null, cart_list_items)

        }

    })

    // Add to and remove from cart
    $(document).on("ghostpress-cart-datalayer-push", function (event, data){

        let cart_data = null

        if (data.action && data.action === "remove"){
            delete data["action"]
            datalayer_push('ga', 'remove_from_cart', null, data)
        }
        else {
            delete data["action"]
            if (data.cart){
                cart_data = data.cart
                delete data["cart"]
            }

            // Google Analytics
            datalayer_push('ga', 'add_to_cart', cart_data, data)

            // Ads
            let addToCart = {
                "content_ids": [data["item_id"]],
                "value": parseFloat(data["price"])
            }
            datalayer_push('ads', 'addToCart', addToCart)
        }
    })

    /*
        CHECKOUT
     */

    // Begin checkout
    let checkout_list_items = get_checkout_items()

    if (checkout_list_items.length > 0){
        datalayer_push('ga', 'begin_checkout', null, checkout_list_items)

        let item_ids = []
        $.each(checkout_list_items, function (index, item){
            item_ids.push(item["item_id"])
        })

        let initiateCheckout = {
            "content_ids": item_ids
        }

        let order_total = $('div.d-lg-block div.checkout_review__summary_total[data-cart-total]').attr('data-cart-total')
        if (order_total){
            initiateCheckout["value"] = order_total
        }

        datalayer_push('ads', 'initiateCheckout', initiateCheckout)
    }

    // Complete checkout
    function push_checkout(){
        // - Shipping info
        let shipping = $('input.shipping_method[type=radio]:checked').siblings('label')
        let shipping_data = {}
        if (shipping){
            const shipping_name = shipping.find("span.payment_method_title")
            if (shipping_name.length > 0){
                shipping_data = {'shipping_tier': shipping_name.text()}
            }
        }

        let items = get_checkout_items()
        $.each(items, function (index){
            delete items[index]["item_list_name"]
            delete items[index]["item_list_id"]
        })
        datalayer_push('ga', 'add_shipping_info', shipping_data, items)

        // - Payment info
        let payment = $('input[name=payment_method][type=radio]:checked').siblings('label')
        let payment_data = {}
        if (payment){
            const payment_name = payment.find("span.payment_method_title")
            if (payment_name.length > 0){
                payment_data = {'payment_type': payment_name.text()}
            }
        }

        datalayer_push('ga', 'add_payment_info', payment_data, items)
    }

    $('button[type="submit"]#place_order').on('click', () => {
        push_checkout()
    })

})(jQuery)
